import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MyCoursesCard.css';

export default function MyCoursesCard({ title, img, path }) {
    const navigate = useNavigate();

    const handleHomeworkClick = () => {
        navigate('/homework');
    };
    const handleLessonClick = () => {
        navigate('/lesson');
    };

    return (
        <div className="VideoCard__item" onClick={handleLessonClick}>
            <div className="VideoCard__item-box">
                <div className="VideoCard__item-date">
                    <span>{title}</span>
                </div>
                <div className="VideoCard__item-img">
                    <img src={`${img}`} alt="" />
                </div>
            </div>
            <div className="VideoCard__item-content">
                <div className="VideoCard__item-date dn">
                    <span>{title}</span>
                </div>
                <div>
                    Просмотрено/не просмотрено
                </div>
                <button className='homework__route' onClick={handleHomeworkClick}>
                    Домашняя работа
                </button>
                <a href={`/pdf/${path}`} className="VideoCard__item-btn" download>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.001 14.9425L12.001 3M12.001 3L7.06835 7.56318M12.001 3L16.9336 7.56318M4 18.9663V20.3827C4.40471 20.778 4.95361 21 5.52595 21H18.4741C19.0464 21 19.5953 20.778 20 20.3827V18.9663" stroke="#6446C3" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> Скачать конспект
                </a>
            </div>
        </div>
    );
}
